import { useQuery } from 'react-query'
import { getPayoutSchedule } from './payout-schedule.api'

export function usePayoutSchedule(merchantId: string) {
  return useQuery({
    queryKey: ['payoutSchedule'],
    queryFn: () => getPayoutSchedule(merchantId),
  })
}
